import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import { ToastContainer, toast } from 'react-toastify'


import axios from 'axios';

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

function SectionUnlinkModal(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =useState(false);
  const [openDeleteConfirmaitonModal, setopenDeleteConfirmaitonModal] =useState(false);
  const [openUnlinkConfirmaitonModal, setopenUnlinkConfirmaitonModal] =useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const columns = [
    {
    field: "linkedSectionName",
    headerName: "Linked Section",
    align: "center",
    headerAlign: "center",
    flex: 1,
    },
    {
    field: "RestaurantName",
    headerName: "Restaurant Name",
    align: "center",
    headerAlign: "center",
    flex: 1,
    },
    {
    field: "MenuName",
    headerName: "Menu Name",
    align: "center",
    headerAlign: "center",
    flex: 1,
    },
];

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const { open, onClose, dialogType, id,cancledRes,cancleMenus,linkdata, onToggleSwitch ,selectedRestaurants,openDialog: toggle, linkedFoodItems,linkedFooditem,Status,linkedSection} = props;

  console.log(id);
  console.log(cancledRes);
  console.log(linkedSection);

const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  const handleClose = () => {
    props.onClose()
    //props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
    
  };



  useEffect(() => {
    //loadData();
    console.log(linkedSection)
    loadData()
  }, [linkedSection]);

  const loadData =() => {
    axios({
        method: 'get',
        url: apiAddress + '/api/Section/GetLinkedSectionInfoBySectionId?sectionId=' + linkedSection[0]?.linkedSectionId,
    })
        .then((response) => {
            console.log(response)
            var list = [];
            response.data.map((dt, i) => {
                var obj = {
                    id: dt.id,
                    linkSectionId: dt.linkedSectionId,
                    linkedSectionName: dt.linkedSectionName,
                    RestaurantName: dt.linkedRestaurantName,
                    MenuName: dt.linkedMenuName,
                }
                list.push(obj);
            })
            setDataRows(list);
        })
        .catch((error) => {

        });
    }


const unlinkSubmit = () => {
    console.log(selectedDataRows)
  
    if (selectedDataRows.length == 0) {
        toast.error("Please select a Food Item!!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else{
        console.log(selectedDataRows)
        var list=[]
        selectedDataRows.forEach((id) => {
            console.log(id);
            var obj = dataRows.find((x) => x.id === id);    
            if (obj) {
              list.push(obj);
              console.log(list)
              if (list && list.length > 0) {
                let sectionIds=[]
                let linkedSectionIds=[]
                linkedSection.forEach((dt) => {
                    sectionIds.push(dt.linkedSectionId)    
                });

                list.forEach((dt) => {
                    linkedSectionIds.push(dt.linkSectionId)
                });

                const data={
                    sectionIds:sectionIds,
                    linkedSectionIds:linkedSectionIds
                }
                console.log(data)

                var url = apiAddress + '/api/Section/UnlinkSection'; 

                axios.put(url, data).then((response) => {
                console.log(response.data);
                toast.success("Section Succesfully Unlinked", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
                    //console.log(canceledObjs)
                    //props.onHandleAddItem(canceledObjs);
                    setSelectedValue(null);
                    setopenMenuCloseConfirmaitonModal(false);
                    setopenUnlinkConfirmaitonModal(false);
                    setOpenDialog(false);
                    props.onClose();


                })
              }
            }

      }
    )
}
}
  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={'md'}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={'Do you want to leave without saving?'}
            bodyText={'All changes made will be lost'}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
            <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={
                <>
                  Selected Food Item will be unlinked from <strong>{dataRows[0]?.FoodName}</strong>
                </>
              }
            open={openUnlinkConfirmaitonModal }
            onyes={unlinkSubmit}
            close={() => {
              setopenUnlinkConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={9}>
              <DialogTitle>
                <div className='d-flex' style={{ gap: '8px' }}>
                  <div>
                    <img src={itemImg} style={{ width: '1.8rem' }} alt='' />
                  </div>

                  <span style={{ color: '#2a7fd4' }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={3}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            {/* {dataRows.map((dt,i)=>(
            <span>
            <p>This menu {dt.menuName} will be disabled For these Restaurant's</p>
          </span>
            ))} */}
            {/* {
              dataRows.length > 0 && Status=="Single Archive" && (
                <span>
                  <p>
                     
                  <b>{`{${dataRows.map(row => row.foodName).join(', ')}}`}</b> in <b>{`{${dataRows.map(row => row.sectionName).join(', ')}}`}</b> will be removed from the restaurant/menus below
                  </p>
                </span>
              )
            }
            {
              dataRows.length > 0 && Status=="Bulk Archive" && (
                <span>
                  <p>
                    {dataRows.length === 1 ? (
                      <>
                        <b>{`{${dataRows.length}}`}</b> food item and related item in <b>{`{${dataRows.length}}`}</b> section will be removed from the restaurant/menus below
                      </>
                    ) : (
                      <>
                        <b>{`{${dataRows.length}}`}</b> food items and related items in <b>{`{${dataRows.length}}`}</b> sections will be removed from the restaurant/menus below
                      </>
                    )}
                  </p>
                </span>
              )
            } */}
            <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData}/>

          </DialogContent>
          <DialogActions>
            <Button
                onClick={() => setopenUnlinkConfirmaitonModal(true)}
                color="error"
            >
                Unlink
            </Button>
            <Button
                onClick={() => setopenMenuCloseConfirmaitonModal(true)}
                color='primary'
            >
                Close
            </Button>
            </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default SectionUnlinkModal;
